// extracted by mini-css-extract-plugin
export default {"item":"styles_item__XyvDd","content":"styles_content__7TwIc","text":"styles_text__rlC90","action":"styles_action__dZ2Ys","btn":"styles_btn__cjxGU"};